import React from 'react'
import styles from './coursetags.module.scss'
import { ERCText } from 'components/text'

const CourseTags = ({ tagName, backgroundColor, onClick}) => {
    return (
        <div className={styles.body} style={{backgroundColor}} onClick={onClick}>
            <ERCText color='#00296B' size='18px' weight='600' lHeight='27px' isLink>{tagName}</ERCText>
        </div>
    )
}

export default CourseTags